export const WellDoneSVG = () => {
    return (
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 44C0 68.3005 19.6995 88 44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44ZM80 44C80 63.8822 63.8822 80 44 80C24.1177 80 8 63.8822 8 44C8 24.1177 24.1177 8 44 8C63.8822 8 80 24.1177 80 44ZM44.1283 72C30.6984 72 23.2257 64.9264 23.2257 52V48H64.4631L64.5738 51.8862C64.9431 64.8578 57.6014 72 44.1283 72ZM56.3501 56C55.4105 61.582 51.6358 64 44.1283 64C36.6251 64 32.7272 61.5609 31.5871 56H56.3501ZM52 28H64V36H52V28ZM36 28H24V36H36V28Z"
                fill="white"
            />
        </svg>
    );
};

export const GoodTrySVG = () => {
    return (
        <svg viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 44C0 68.3005 19.6995 88 44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44ZM80 44C80 63.8822 63.8822 80 44 80C24.1177 80 8 63.8822 8 44C8 24.1177 24.1177 8 44 8C63.8822 8 80 24.1177 80 44ZM43.6843 45.3818C57.1143 45.3818 64.5869 52.4555 64.5869 65.3818V69.3818H23.3495L23.2388 65.4957C22.8695 52.524 30.2113 45.3818 43.6843 45.3818ZM31.4622 61.3819C32.4019 55.7999 36.1766 53.3819 43.684 53.3819C51.1873 53.3819 55.0852 55.8209 56.2253 61.3819H31.4622ZM52 28H64V36H52V28ZM36 28H24V36H36V28Z"
                fill="white"
            />
        </svg>
    );
};

export const WarningSVG = () => {
    return (
        <svg
            viewBox="0 0 116 116"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.25 58C0.25 89.8944 26.1056 115.75 58 115.75C89.8944 115.75 115.75 89.8944 115.75 58C115.75 26.1056 89.8944 0.25 58 0.25C26.1056 0.25 0.25 26.1056 0.25 58ZM105.25 58C105.25 84.0955 84.0955 105.25 58 105.25C31.9045 105.25 10.75 84.0955 10.75 58C10.75 31.9045 31.9045 10.75 58 10.75C84.0955 10.75 105.25 31.9045 105.25 58ZM63.269 68.4913H68.5155V78.9913H47.5155V68.4913H52.7655V57.9913H47.5155V47.4913H63.269V68.4913ZM63.2534 36.9913C63.2534 39.8908 60.9022 42.2413 58.0017 42.2413C55.1013 42.2413 52.75 39.8908 52.75 36.9913C52.75 34.0918 55.1013 31.7413 58.0017 31.7413C60.9022 31.7413 63.2534 34.0918 63.2534 36.9913Z"
                fill="white"
            />
        </svg>
    );
};

export const SupportedDevises = () => {
    return (
        <svg
            viewBox="0 0 181 66"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M93.75 43.6665L93.75 20.3332C93.75 18.7223 92.183 17.4165 90.25 17.4165L58.75 17.4165C56.817 17.4165 55.25 18.7223 55.25 20.3332L55.25 43.6665C55.25 45.2773 56.817 46.5832 58.75 46.5832L90.25 46.5832C92.183 46.5832 93.75 45.2773 93.75 43.6665ZM58.75 20.3332L90.25 20.3332L90.25 43.6665L58.75 43.6665L58.75 20.3332Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M139.75 52.25V55H134.25V60.5H161.75V55H156.25V52.25H172.75C175.788 52.25 178.25 49.7876 178.25 46.75V11C178.25 7.96243 175.788 5.5 172.75 5.5H123.25C120.212 5.5 117.75 7.96243 117.75 11V46.75C117.75 49.7876 120.212 52.25 123.25 52.25H139.75ZM172.75 46.75H123.25V11H172.75V46.75Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.666 16.3335H11.3327C9.85992 16.3335 8.66602 17.5274 8.66602 19.0002V43.0002C8.66602 44.4729 9.85992 45.6668 11.3327 45.6668H24.666C26.1388 45.6668 27.3327 44.4729 27.3327 43.0002V19.0002C27.3327 17.5274 26.1388 16.3335 24.666 16.3335ZM11.3327 19.0002H15.3327C15.3327 19.7365 15.9296 20.3335 16.666 20.3335H19.3327C20.0691 20.3335 20.666 19.7365 20.666 19.0002H24.666V43.0002H11.3327V19.0002Z"
                fill="white"
            />
            <rect
                x="0.585786"
                y="17.4375"
                width="5"
                height="43.1769"
                rx="2.5"
                transform="rotate(-45 0.585786 17.4375)"
                fill="white"
                stroke="#1A2552"
                strokeWidth="2"
            />
        </svg>
    );
};

export const RotateDevice = () => {
    return (
        <svg
            viewBox="0 0 159 159"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M141.883 110.884C141.883 108.212 144.03 106.062 146.7 106.062C149.37 106.062 151.518 108.211 151.518 110.884V121.903C151.518 124.575 149.37 126.724 146.7 126.724C144.03 126.724 141.883 124.576 141.883 121.903V110.884ZM146.699 122.591C147.084 122.591 147.388 122.288 147.388 121.902V110.884C147.388 110.498 147.084 110.195 146.699 110.195C146.313 110.195 146.011 110.498 146.011 110.884V121.903C146.011 122.289 146.313 122.591 146.699 122.591V122.591Z"
                fill="white"
            />
            <path
                d="M6.19336 116.393C6.19336 112.537 9.33132 109.395 13.1862 109.395C17.0411 109.395 20.1791 112.535 20.1791 116.393C20.1791 120.249 17.0411 123.391 13.1862 123.391C9.33132 123.391 6.19336 120.25 6.19336 116.393V116.393ZM13.1862 119.258C14.7564 119.258 16.0492 117.991 16.0492 116.393C16.0492 114.794 14.7552 113.528 13.1862 113.528C11.5902 113.528 10.3233 114.794 10.3233 116.393C10.322 117.964 11.589 119.258 13.1862 119.258Z"
                fill="white"
            />
            <path
                d="M24.1997 84.0244H137.066C137.617 84.0244 138.139 84.2442 138.524 84.6297C138.91 85.0152 139.13 85.5394 139.13 86.0906V146.697C139.13 147.249 138.91 147.77 138.524 148.158C138.139 148.545 137.616 148.764 137.066 148.764H24.1997C23.6485 148.764 23.1267 148.544 22.7412 148.158C22.3557 147.773 22.136 147.249 22.136 146.697L22.1348 116.393V86.0919C22.1348 85.5406 22.3545 85.0188 22.74 84.6309C23.1255 84.2454 23.6485 84.0257 24.1997 84.0257V84.0244ZM135.001 88.1566H26.2646V144.631H135.001V88.1566Z"
                fill="white"
            />
            <path
                d="M47.4839 16.5319H36.4717C33.8015 16.5319 31.6543 14.3835 31.6543 11.7108C31.6543 9.03936 33.8015 6.88965 36.4717 6.88965H47.4839C50.1541 6.88965 52.3013 9.03807 52.3013 11.7108C52.3013 14.3835 50.1541 16.5319 47.4839 16.5319V16.5319ZM36.4729 12.3997H47.4852C47.8707 12.3997 48.1739 12.0965 48.1739 11.711C48.1739 11.3255 47.8707 11.0223 47.4852 11.0223H36.4729C36.0874 11.0223 35.7842 11.3255 35.7842 11.711C35.7854 12.0965 36.0874 12.3997 36.4729 12.3997Z"
                fill="white"
            />
            <path
                d="M70.1979 23.4177H13.7648V74.3823H70.1979V23.4177ZM7.37849 157.41C3.0558 155.591 0 151.294 0 146.308V12.0928C0 5.42646 5.42269 0 12.0865 0H71.8793C78.5406 0 83.9658 5.42646 83.9658 12.0928V74.3779H146.32C152.981 74.3779 158.407 79.8044 158.407 86.4707V146.304C158.4 152.972 152.978 158.398 146.314 158.398H12.1955C11.7818 158.398 11.3705 158.37 10.9568 158.344C10.5996 158.29 10.2681 158.262 9.93784 158.178C9.88382 158.178 9.82735 158.15 9.7721 158.15C9.35838 158.068 8.97288 157.984 8.61563 157.847C8.1749 157.709 7.7894 157.571 7.37813 157.407L7.37849 157.41ZM4.12877 77.4937C5.6425 76.1151 7.54286 75.0961 9.6338 74.6566L9.63503 21.3506C9.63503 20.7994 9.85478 20.2776 10.2403 19.8897C10.6258 19.5042 11.1488 19.2844 11.6988 19.2844H72.2616C72.8128 19.2844 73.3346 19.5042 73.7201 19.8897C74.1056 20.2752 74.3253 20.7994 74.3253 21.3506V74.38H79.8304V12.0949C79.8304 7.71436 76.2516 4.13465 71.8752 4.13465H12.0855C7.70871 4.13465 4.13025 7.71594 4.13025 12.0949L4.12877 77.4937ZM12.1946 78.5127C7.81786 78.5127 4.2394 82.094 4.2394 86.4729L4.24063 116.39V146.306C4.24063 148.758 5.36885 150.99 7.13058 152.448C7.35033 152.614 7.54431 152.752 7.76405 152.916C7.98381 153.082 8.17778 153.219 8.42456 153.302C8.86405 153.55 9.33303 153.741 9.82904 153.907C10.2145 154.017 10.5718 154.101 10.9855 154.155C11.0678 154.183 11.177 154.209 11.2888 154.209C11.371 154.209 11.4545 154.237 11.5367 154.237C11.7565 154.265 11.9762 154.265 12.1972 154.265H146.316C150.692 154.265 154.271 150.684 154.271 146.305L154.268 121.902V86.4753C154.268 82.0947 150.69 78.515 146.313 78.515L12.1946 78.5127Z"
                fill="white"
            />
            <path
                d="M133.284 51.3821C134.239 52.4496 134.239 54.2139 133.284 55.2814L126.216 63.1916C125.988 63.4507 125.722 63.6344 125.428 63.7786C125.131 63.9262 124.803 64 124.473 64C124.145 64 123.815 63.9278 123.519 63.7786C123.223 63.6311 122.96 63.4474 122.73 63.1916L115.662 55.2814C114.708 54.2139 114.708 52.4496 115.662 51.3821C116.647 50.3146 118.193 50.3146 119.147 51.3821L122.007 54.5845L122.007 51.5313C122.007 47.3729 120.528 43.6555 118.096 40.9337C115.664 38.2117 112.309 36.5194 108.628 36.5194H103.466C102.119 36.5194 101 35.3043 101 33.7597C101 32.2511 102.119 31 103.466 31H108.628C118.754 31 126.939 40.1989 126.939 51.5311L126.939 54.5843L129.799 51.3819C130.751 50.3144 132.33 50.3144 133.284 51.3819L133.284 51.3821Z"
                fill="white"
            />
        </svg>
    );
};

export const TotalScoreSVG = () => {
    return (
        <svg
            viewBox="0 0 126 126"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M104.343 44.2107H77.2354L101.611 13.4121C102.115 12.76 101.66 11.8125 100.836 11.8125H53.6473C53.3028 11.8125 52.9706 11.9971 52.7983 12.3047L20.9169 67.3682C20.5354 68.0203 21.003 68.8447 21.7659 68.8447H43.2253L32.2249 112.846C31.9911 113.806 33.1477 114.483 33.8614 113.794L105.019 45.8965C105.659 45.2936 105.229 44.2107 104.343 44.2107ZM46.5352 90.1318L53.955 60.4775H34.5874L57.9171 20.192H85.5534L59.9227 52.5902H85.8856L46.5352 90.1318Z"
                fill="white"
            />
        </svg>
    );
};

export const Type5LineSVG = ({ startX, startY, endX, endY }) => {
    return (
        <svg>
            <circle cx={startX} cy={startY} r="5" fill="#fff" />
            <line
                x1={startX}
                y1={startY}
                x2={endX}
                y2={endY}
                strokeWidth="4"
                stroke="#fff"></line>
        </svg>
    );
};

export const Type6SelectSVG = ({
    onClick,
    left,
    top,
    width,
    height,
    color,
    index,
}) => {
    return (
        <div
            className="type-6-SVG"
            style={{
                left: left,
                top: top,
                width: width,
                height: height,
            }}>
            <svg
                preserveAspectRatio="none"
                onClick={() => onClick(index)}
                viewBox="0 0 372 265"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`(url(#clip0_1047_13915-${index})`}>
                    <rect width="8" height="53.4274" fill={color} />
                    <rect
                        x="50"
                        width="8.54839"
                        height="50"
                        transform="rotate(90 50 0)"
                        fill={color}
                    />
                    <rect
                        x="372"
                        width="8.54839"
                        height="50"
                        transform="rotate(90 372 0)"
                        fill={color}
                    />
                    <rect
                        x="372"
                        y="53.4272"
                        width="8"
                        height="53.4274"
                        transform="rotate(-180 372 53.4272)"
                        fill={color}
                    />
                    <rect
                        x="372"
                        y="265"
                        width="8"
                        height="53.4274"
                        transform="rotate(-180 372 265)"
                        fill={color}
                    />
                    <rect
                        x="322"
                        y="265"
                        width="8.54839"
                        height="50"
                        transform="rotate(-90 322 265)"
                        fill={color}
                    />
                    <rect
                        y="265"
                        width="8.54839"
                        height="50"
                        transform="rotate(-90 0 265)"
                        fill={color}
                    />
                    <rect y="211.573" width="8" height="53.4274" fill={color} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M221.568 -211.241L217.263 -216L-115 173.663L-110.695 178.422L221.568 -211.241ZM230.524 -202.921L226.219 -207.68L-106.044 181.984L-101.739 186.742L230.524 -202.921ZM235.651 -198.73L239.956 -193.972L-92.3074 195.692L-96.6123 190.933L235.651 -198.73ZM249.386 -185.025L245.081 -189.783L-87.1826 199.88L-82.8777 204.639L249.386 -185.025ZM254.514 -180.836L258.819 -176.077L-73.4441 213.586L-77.749 208.828L254.514 -180.836ZM268.249 -167.128L263.944 -171.887L-68.3193 217.777L-64.0144 222.535L268.249 -167.128ZM273.376 -162.939L277.681 -158.181L-54.5828 231.483L-58.8877 226.724L273.376 -162.939ZM287.112 -149.234L282.807 -153.992L-49.4561 235.671L-45.1511 240.43L287.112 -149.234ZM292.237 -145.043L296.542 -140.284L-35.7214 249.379L-40.0264 244.621L292.237 -145.043ZM305.976 -131.339L301.671 -136.098L-30.5928 253.566L-26.2878 258.324L305.976 -131.339ZM311.1 -127.148L315.405 -122.39L-16.8581 267.274L-21.1631 262.515L311.1 -127.148ZM324.837 -113.443L320.532 -118.201L-11.7314 271.462L-7.42651 276.221L324.837 -113.443ZM329.964 -109.254L334.269 -104.495L2.00513 285.168L-2.29981 280.41L329.964 -109.254ZM343.698 -95.5462L339.393 -100.305L7.12988 289.359L11.4348 294.117L343.698 -95.5462ZM348.827 -91.3594L353.132 -86.6009L20.8684 303.063L16.5635 298.304L348.827 -91.3594ZM362.562 -77.6516L358.257 -82.4102L25.9932 307.253L30.2981 312.012L362.562 -77.6516ZM367.688 -73.4629L371.993 -68.7044L39.7297 320.959L35.4248 316.201L367.688 -73.4629ZM381.425 -59.7571L377.12 -64.5156L44.8565 325.148L49.1614 329.906L381.425 -59.7571ZM386.55 -55.5664L390.854 -50.8079L58.5911 338.856L54.2861 334.097L386.55 -55.5664ZM400.288 -41.8626L395.983 -46.6211L63.7197 343.042L68.0247 347.801L400.288 -41.8626ZM405.413 -37.6719L409.718 -32.9134L77.4544 356.75L73.1494 351.992L405.413 -37.6719ZM419.149 -23.9661L414.844 -28.7246L82.5811 360.939L86.886 365.697L419.149 -23.9661ZM424.276 -19.7773L428.581 -15.0188L96.3176 374.645L92.0127 369.886L424.276 -19.7773ZM438.011 -6.06961L433.706 -10.8281L101.442 378.835L105.747 383.594L438.011 -6.06961ZM443.137 -1.88086L447.442 2.87766L115.179 392.541L110.874 387.783L443.137 -1.88086ZM456.874 11.8249L452.569 7.06641L120.306 396.73L124.611 401.488L456.874 11.8249ZM462.001 16.0137L466.306 20.7722L134.042 410.436L129.737 405.677L462.001 16.0137ZM475.737 29.7195L471.432 24.9609L139.169 414.624L143.474 419.383L475.737 29.7195ZM480.862 33.9102L485.167 38.6687L152.904 428.332L148.599 423.574L480.862 33.9102ZM494.599 47.6159L490.294 42.8574L158.03 432.521L162.335 437.279L494.599 47.6159ZM502.873 48.5391L507.178 53.2976L174.914 442.961L170.609 438.203L502.873 48.5391ZM521.095 57.5905L516.79 52.832L184.526 442.496L188.831 447.254L521.095 57.5905ZM530.709 57.123L535.014 61.8816L202.75 451.545L198.445 446.787L530.709 57.123ZM548.931 66.1745L544.626 61.416L212.362 451.08L216.667 455.838L548.931 66.1745Z"
                        fill={`url(#paint0_radial_1047_13915-${index})`}
                    />
                </g>
                <rect
                    x="1.5"
                    y="1.5"
                    width="369"
                    height="262"
                    stroke={color}
                    strokeWidth="3"
                />
                <defs>
                    <radialGradient
                        id={`paint0_radial_1047_13915-${index}`}
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(185.966 140.382) rotate(147.565) scale(226.896 249.75)">
                        <stop stopColor={color} stopOpacity="0" />
                        <stop
                            offset="0.302083"
                            stopColor={color}
                            stopOpacity="0"
                        />
                        <stop offset="1" stopColor={color} />
                    </radialGradient>
                    <clipPath id={`clip0_1047_13915-${index}`}>
                        <rect width="372" height="265" fill={color} />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};

export const HomeButtonSVG = () => {
    return (
        <svg viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6755 16.875L31.5505 3.75L48.4255 16.875V37.5C48.4255 38.4946 48.0304 39.4484 47.3272 40.1516C46.6239 40.8549 45.6701 41.25 44.6755 41.25H18.4255C17.431 41.25 16.4771 40.8549 15.7739 40.1516C15.0706 39.4484 14.6755 38.4946 14.6755 37.5V16.875Z"
                stroke="white"
                strokeWidth="3.77105"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.9255 41.25V22.5H37.1755V41.25"
                stroke="white"
                strokeWidth="3.77105"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9543 51.9961H15.757V57.9043H8.85273V51.9961H6.65547V66H8.85273V59.8965H15.757V66H17.9543V51.9961ZM28.4477 61.2051C28.4477 62.1035 28.1449 62.8555 27.559 63.4707C26.9633 64.0957 26.2602 64.3984 25.4496 64.3984C24.6293 64.3984 23.9262 64.0957 23.3305 63.4707C22.7348 62.8555 22.4418 62.1035 22.4418 61.2051C22.4418 60.3066 22.7348 59.5547 23.3305 58.9297C23.9262 58.3145 24.6293 58.002 25.4496 58.002C26.2602 58.002 26.9633 58.3145 27.559 58.9297C28.1449 59.5547 28.4477 60.3066 28.4477 61.2051ZM20.4496 61.2051C20.4496 62.5527 20.9379 63.7148 21.934 64.7109C22.9301 65.707 24.102 66.2051 25.4496 66.2051C26.7973 66.2051 27.9594 65.707 28.9555 64.7109C29.9516 63.7148 30.4496 62.5527 30.4496 61.2051C30.4496 59.8574 29.9516 58.6855 28.9555 57.6895C27.9594 56.6934 26.7973 56.1953 25.4496 56.1953C24.102 56.1953 22.9301 56.6934 21.934 57.6895C20.9379 58.6855 20.4496 59.8574 20.4496 61.2051ZM44.8492 66H46.8512V60.4043C46.8512 59.0371 46.5289 57.9922 45.8844 57.2695C45.2398 56.5566 44.3609 56.1953 43.2379 56.1953C42.8277 56.1953 42.4371 56.2539 42.0562 56.3711C41.6754 56.4883 41.3629 56.6152 41.1285 56.752C40.8941 56.8887 40.6793 57.0547 40.4742 57.2402C40.2691 57.4355 40.1324 57.5625 40.0738 57.6309C40.0152 57.709 39.9664 57.7578 39.9371 57.7969L39.8395 57.6406C39.7809 57.543 39.6734 57.4062 39.5172 57.2402C39.3609 57.084 39.1852 56.918 38.9703 56.7617C38.7652 56.6055 38.4918 56.4688 38.1402 56.3613C37.7887 56.2539 37.4273 56.1953 37.0367 56.1953C36.5582 56.1953 36.0992 56.3125 35.65 56.5273C35.2008 56.752 34.9078 56.9277 34.7711 57.0645C34.6344 57.2012 34.5172 57.3086 34.4391 57.3965V56.4004H32.4371V66H34.4391V60.8047C34.4391 59.9355 34.6539 59.252 35.0738 58.7539C35.4937 58.2559 36.0113 58.002 36.6363 58.002C37.2516 58.002 37.7398 58.207 38.1012 58.6172C38.4625 59.0273 38.6383 59.623 38.6383 60.4043V66H40.6402V60.8047C40.6402 59.9355 40.8551 59.252 41.275 58.7539C41.6949 58.2559 42.2125 58.002 42.8375 58.002C43.4527 58.002 43.941 58.207 44.3023 58.6172C44.6637 59.0273 44.8395 59.623 44.8395 60.4043L44.8492 66ZM58.3504 61.8984L58.4578 60.9023C58.4578 59.5547 58.0086 58.4414 57.1102 57.543C56.2117 56.6445 55.0984 56.1953 53.7508 56.1953C52.4031 56.1953 51.2508 56.6836 50.2938 57.6406C49.3367 58.5977 48.8484 59.75 48.8484 61.0977C48.8484 62.5039 49.3465 63.7051 50.3328 64.7012C51.3191 65.6973 52.491 66.1953 53.8484 66.1953C54.3563 66.1953 54.8543 66.127 55.3328 65.9805C55.8113 65.834 56.202 65.6777 56.4949 65.502C56.7977 65.3262 57.0809 65.1309 57.3445 64.9062C57.618 64.6816 57.7938 64.5254 57.8719 64.4277C57.95 64.3301 58.0086 64.2617 58.0477 64.2031L56.7488 62.9043L56.4461 63.2754C56.2508 63.5195 55.909 63.7637 55.4207 64.0176C54.9324 64.2715 54.4148 64.3984 53.8484 64.3984C53.077 64.3984 52.4129 64.1543 51.8465 63.6562C51.2801 63.168 50.948 62.582 50.8406 61.8984H58.3504ZM53.741 57.9043C54.4832 57.9043 55.0887 58.1191 55.577 58.5488C56.0652 58.9785 56.368 59.5254 56.4852 60.1992H50.9285C51.1043 59.5254 51.4363 58.9785 51.9246 58.5488C52.4129 58.1191 53.0184 57.9043 53.741 57.9043Z"
                fill="white"
            />
        </svg>
    );
};
export const AudioUnmuteSVG = () => {
    return (
        <svg viewBox="0 0 74 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6667 16.877L37.5 12.9603V34.0397L29.6667 30.123V16.877ZM27.246 13.7084L41.4167 6.62305V40.377L27.2461 33.2917H19.875C17.7119 33.2917 15.9583 31.5381 15.9583 29.375V17.625C15.9583 15.4619 17.7119 13.7084 19.875 13.7084H27.246ZM25.75 17.625H19.875V29.375H25.75V17.625ZM52.5382 6.7703C56.5225 10.734 59.0417 16.7801 59.0417 23.5009C59.0417 30.2217 56.5225 36.2678 52.5382 40.2315L49.452 37.7625C52.8705 34.5726 55.125 29.3997 55.125 23.5009C55.125 17.6021 52.8705 12.4292 49.452 9.23929L52.5382 6.7703ZM51.2083 23.5007C51.2083 18.7799 49.3771 14.5167 46.4589 11.6336L43.3696 14.105C45.739 16.2387 47.2916 19.6343 47.2916 23.5007C47.2916 27.3671 45.739 30.7628 43.3696 32.8965L46.4589 35.3679C49.3771 32.4848 51.2083 28.2216 51.2083 23.5007Z"
                fill="white"
            />
            <path
                d="M8.26172 64.2031C7.26562 64.2031 6.39648 63.832 5.66406 63.0898C4.93164 62.3477 4.57031 61.4492 4.57031 60.4043V51.9961H2.36328V60.4043C2.36328 62.0059 2.92969 63.3633 4.08203 64.4961C5.23438 65.6289 6.62109 66.1953 8.26172 66.1953C9.90234 66.1953 11.2891 65.6387 12.4414 64.5059C13.5938 63.373 14.1699 62.0059 14.1699 60.4043V51.9961H11.9629V60.4043C11.9629 61.4395 11.5918 62.3379 10.8594 63.0801C10.127 63.832 9.25781 64.2031 8.26172 64.2031ZM19.0578 56.4004H17.0559V66H19.0578V60.8047C19.0578 59.9258 19.2824 59.2324 19.7316 58.7441C20.1809 58.2559 20.7961 58.002 21.5578 58.002C22.2023 58.002 22.7492 58.2363 23.1887 58.6855C23.6281 59.1445 23.8527 59.7207 23.8527 60.4141V66.0098H25.8547V60.4141C25.8547 59.125 25.4934 58.1094 24.7707 57.3477C24.048 56.5859 23.1105 56.2051 21.9484 56.2051C21.6164 56.2051 21.2941 56.2441 20.9621 56.332C20.6301 56.4199 20.3664 56.5176 20.1516 56.625C19.9367 56.7324 19.7414 56.8496 19.5461 56.9863C19.3605 57.123 19.2336 57.2207 19.175 57.2793L19.048 57.4062L19.0578 56.4004ZM40.8598 66H42.8617V60.4043C42.8617 59.0371 42.5395 57.9922 41.8949 57.2695C41.2504 56.5566 40.3715 56.1953 39.2484 56.1953C38.8383 56.1953 38.4477 56.2539 38.0668 56.3711C37.6859 56.4883 37.3734 56.6152 37.1391 56.752C36.9047 56.8887 36.6898 57.0547 36.4848 57.2402C36.2797 57.4355 36.143 57.5625 36.0844 57.6309C36.0258 57.709 35.977 57.7578 35.9477 57.7969L35.85 57.6406C35.7914 57.543 35.684 57.4062 35.5277 57.2402C35.3715 57.084 35.1957 56.918 34.9809 56.7617C34.7758 56.6055 34.5023 56.4688 34.1508 56.3613C33.7992 56.2539 33.4379 56.1953 33.0473 56.1953C32.5688 56.1953 32.1098 56.3125 31.6605 56.5273C31.2113 56.752 30.9184 56.9277 30.7816 57.0645C30.6449 57.2012 30.5277 57.3086 30.4496 57.3965V56.4004H28.4477V66H30.4496V60.8047C30.4496 59.9355 30.6645 59.252 31.0844 58.7539C31.5043 58.2559 32.0219 58.002 32.6469 58.002C33.2621 58.002 33.7504 58.207 34.1117 58.6172C34.473 59.0273 34.6488 59.623 34.6488 60.4043V66H36.6508V60.8047C36.6508 59.9355 36.8656 59.252 37.2855 58.7539C37.7055 58.2559 38.223 58.002 38.848 58.002C39.4633 58.002 39.9516 58.207 40.3129 58.6172C40.6742 59.0273 40.85 59.623 40.85 60.4043L40.8598 66ZM52.2613 66H54.2633V56.4004H52.2613V61.5957C52.2613 62.4844 52.027 63.1777 51.5777 63.666C51.1285 64.1543 50.523 64.3984 49.7613 64.3984C49.107 64.3984 48.5602 64.1738 48.1207 63.7148C47.6813 63.2656 47.4664 62.6895 47.4664 61.9961V56.4004H45.4645V61.9961C45.4645 63.2852 45.816 64.3008 46.5387 65.0625C47.2613 65.8242 48.1988 66.1953 49.3609 66.1953C49.693 66.1953 50.025 66.1562 50.357 66.0684C50.6793 65.9902 50.9527 65.8926 51.1676 65.7852C51.3824 65.6777 51.5777 65.5605 51.7633 65.4238C51.9488 65.2871 52.0758 65.1895 52.1344 65.1309L52.2613 65.0039V66ZM58.1648 55.1992C58.1648 56 57.8328 56.4004 57.1688 56.4004H56.1629V58.1973H57.9695V63.1973C57.9598 65.1992 58.8875 66.1953 60.7527 66.1953C61.2996 66.1953 61.7684 66.1367 62.159 66V64.2031L62.0125 64.2422C61.9246 64.2812 61.7977 64.3203 61.6316 64.3496C61.4656 64.3887 61.3094 64.3984 61.1531 64.3984C60.8113 64.3984 60.5281 64.291 60.3035 64.0566C60.0691 63.832 59.9617 63.5391 59.9617 63.1777V58.1973H61.9637V56.4004H59.9617V53.1973H58.1648V55.1992ZM72.4375 61.8984L72.5449 60.9023C72.5449 59.5547 72.0957 58.4414 71.1973 57.543C70.2988 56.6445 69.1855 56.1953 67.8379 56.1953C66.4902 56.1953 65.3379 56.6836 64.3809 57.6406C63.4238 58.5977 62.9355 59.75 62.9355 61.0977C62.9355 62.5039 63.4336 63.7051 64.4199 64.7012C65.4062 65.6973 66.5781 66.1953 67.9355 66.1953C68.4434 66.1953 68.9414 66.127 69.4199 65.9805C69.8984 65.834 70.2891 65.6777 70.582 65.502C70.8848 65.3262 71.168 65.1309 71.4316 64.9062C71.7051 64.6816 71.8809 64.5254 71.959 64.4277C72.0371 64.3301 72.0957 64.2617 72.1348 64.2031L70.8359 62.9043L70.5332 63.2754C70.3379 63.5195 69.9961 63.7637 69.5078 64.0176C69.0195 64.2715 68.502 64.3984 67.9355 64.3984C67.1641 64.3984 66.5 64.1543 65.9336 63.6562C65.3672 63.168 65.0352 62.582 64.9277 61.8984H72.4375ZM67.8281 57.9043C68.5703 57.9043 69.1758 58.1191 69.6641 58.5488C70.1523 58.9785 70.4551 59.5254 70.5723 60.1992H65.0156C65.1914 59.5254 65.5234 58.9785 66.0117 58.5488C66.5 58.1191 67.1055 57.9043 67.8281 57.9043Z"
                fill="white"
            />
        </svg>
    );
};

export const AudioMuteSVG = () => {
    return (
        <svg viewBox="0 0 74 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3014 2.53223L16.5319 5.30173L24.9388 13.7086H19.875C17.7119 13.7086 15.9583 15.4622 15.9583 17.6253V29.3753C15.9583 31.5384 17.7119 33.292 19.875 33.292H27.2461L41.4167 40.3773V30.1865L55.6986 44.4684L58.4681 41.6989L19.3014 2.53223ZM37.5 26.2698L29.6667 18.4365V30.1233L37.5 34.04V26.2698ZM37.5 12.9606V15.2475L41.4167 19.1641V6.62333L33.0561 10.8036L35.9754 13.7229L37.5 12.9606ZM47.2166 24.964L50.5532 28.3006C50.9789 26.7853 51.2083 25.1719 51.2083 23.501C51.2083 18.7801 49.3771 14.5169 46.4589 11.6339L43.3696 14.1053C45.739 16.239 47.2916 19.6346 47.2916 23.501C47.2916 23.997 47.2661 24.4852 47.2166 24.964ZM53.6648 31.4122L56.6366 34.3841C58.1683 31.1819 59.0417 27.4585 59.0417 23.5012C59.0417 16.7804 56.5225 10.7343 52.5382 6.77059L49.452 9.23957C52.8705 12.4295 55.125 17.6023 55.125 23.5012C55.125 26.3557 54.5971 29.0402 53.6648 31.4122ZM25.75 17.6253H19.875V29.3753H25.75V17.6253Z"
                fill="white"
            />
            <path
                d="M22.466 58.8027L17.0656 51.9961H15.1711V66H17.3684V55.8047L22.466 62.2012L27.5734 55.8047V66H29.7707V51.9961H27.8664L22.466 58.8027ZM39.6586 66H41.6605V56.4004H39.6586V61.5957C39.6586 62.4844 39.4242 63.1777 38.975 63.666C38.5258 64.1543 37.9203 64.3984 37.1586 64.3984C36.5043 64.3984 35.9574 64.1738 35.518 63.7148C35.0785 63.2656 34.8637 62.6895 34.8637 61.9961V56.4004H32.8617V61.9961C32.8617 63.2852 33.2133 64.3008 33.9359 65.0625C34.6586 65.8242 35.5961 66.1953 36.7582 66.1953C37.0902 66.1953 37.4223 66.1562 37.7543 66.0684C38.0766 65.9902 38.35 65.8926 38.5648 65.7852C38.7797 65.6777 38.975 65.5605 39.1605 65.4238C39.3461 65.2871 39.473 65.1895 39.5316 65.1309L39.6586 65.0039V66ZM45.5621 55.1992C45.5621 56 45.2301 56.4004 44.566 56.4004H43.5602V58.1973H45.3668V63.1973C45.357 65.1992 46.2848 66.1953 48.15 66.1953C48.6969 66.1953 49.1656 66.1367 49.5563 66V64.2031L49.4098 64.2422C49.3219 64.2812 49.1949 64.3203 49.0289 64.3496C48.8629 64.3887 48.7066 64.3984 48.5504 64.3984C48.2086 64.3984 47.9254 64.291 47.7008 64.0566C47.4664 63.832 47.359 63.5391 47.359 63.1777V58.1973H49.3609V56.4004H47.359V53.1973H45.5621V55.1992ZM59.8348 61.8984L59.9422 60.9023C59.9422 59.5547 59.493 58.4414 58.5945 57.543C57.6961 56.6445 56.5828 56.1953 55.2352 56.1953C53.8875 56.1953 52.7352 56.6836 51.7781 57.6406C50.8211 58.5977 50.3328 59.75 50.3328 61.0977C50.3328 62.5039 50.8309 63.7051 51.8172 64.7012C52.8035 65.6973 53.9754 66.1953 55.3328 66.1953C55.8406 66.1953 56.3387 66.127 56.8172 65.9805C57.2957 65.834 57.6863 65.6777 57.9793 65.502C58.282 65.3262 58.5652 65.1309 58.8289 64.9062C59.1023 64.6816 59.2781 64.5254 59.3563 64.4277C59.4344 64.3301 59.493 64.2617 59.532 64.2031L58.2332 62.9043L57.9305 63.2754C57.7352 63.5195 57.3934 63.7637 56.9051 64.0176C56.4168 64.2715 55.8992 64.3984 55.3328 64.3984C54.5613 64.3984 53.8973 64.1543 53.3309 63.6562C52.7645 63.168 52.4324 62.582 52.325 61.8984H59.8348ZM55.2254 57.9043C55.9676 57.9043 56.573 58.1191 57.0613 58.5488C57.5496 58.9785 57.8523 59.5254 57.9695 60.1992H52.4129C52.5887 59.5254 52.9207 58.9785 53.409 58.5488C53.8973 58.1191 54.5027 57.9043 55.2254 57.9043Z"
                fill="white"
            />
        </svg>
    );
};

export const VideoPlaySVG = ({ playBtn, playFunction }) => {
    return (
        <svg
            style={{
                display: playBtn ? 'block' : 'none',
                cursor: 'pointer',
            }}
            onClick={() => {
                playFunction();
            }}
            width="150"
            height="150"
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1610_14197)">
                <g filter="url(#filter0_d_1610_14197)">
                    <circle
                        cx="75"
                        cy="75"
                        r="73"
                        stroke="#000241"
                        strokeWidth="4"
                        strokeLinejoin="round"
                        shapeRendering="crispEdges"
                    />
                </g>
                <g filter="url(#filter1_d_1610_14197)">
                    <path
                        d="M58 112V38L111 75L58 112Z"
                        stroke="#000241"
                        strokeWidth="4"
                        strokeLinejoin="round"
                        shapeRendering="crispEdges"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_1610_14197"
                    x="-4"
                    y="0"
                    width="158"
                    height="158"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1610_14197"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1610_14197"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_1610_14197"
                    x="52"
                    y="36"
                    width="65"
                    height="86"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1610_14197"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1610_14197"
                        result="shape"
                    />
                </filter>
                <clipPath id="clip0_1610_14197">
                    <rect width="150" height="150" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
